
<p-toast></p-toast>

<div class="login-body">
    <div class="login-image">
        <img [src]="'assets/layout/images/pages/login-ondark.png'"
             alt="Elevadores">
    </div>
    <div class="login-panel p-fluid">
        <div class="p-d-flex p-flex-column">
            <div class="p-d-flex p-ai-center p-mb-6 logo-container">
                <!-- <img [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'"
                     class="login-logo"/>
                <img [src]="'assets/layout/images/appname-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'"
                     class="login-appname"/> -->
                     <h2 style="margin-bottom: 0px;">Elevator Acesso Cliente</h2>
            </div>
            <div class="form-container">
                <span class="p-input-icon-left">
                    <i class="pi pi-envelope"></i>
                    <input [(ngModel)]="cliente.login" type="text" autocomplete="off" pInputText placeholder="Login">
                </span>
                <span class="p-input-icon-left">
                    <i class="pi pi-key"></i>
                    <input [(ngModel)]="cliente.senha_nova" type="password" autocomplete="off" pInputText placeholder="Senha">
                </span>
                <!-- <a href="#" class="p-d-flex">Esqueceu sua senha?</a> -->
            </div>
            <div class="button-container">
                <button type="button" pButton label="Acessar" style="background-color: #E60000;"
                (click)="onClickLogin()"
                [disabled]="!cliente.login || !cliente.senha_nova"></button>
                <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>
                <!-- <span>Não tem uma conta?<a>Cadastre-se aqui</a></span> -->
            </div>
        </div>

        <div class="login-footer p-d-flex p-ai-center">
            <div class="p-d-flex p-ai-center login-footer-logo-container">
                <label>Elevator</label>
                <!-- <img src="assets/layout/images/logo-gray.png" class="login-footer-logo"/>
                <img src="assets/layout/images/appname-gray.png" class="login-footer-appname"/> -->
            </div>
            <span>Versão : {{version}}</span>
        </div>
    </div>
</div>
